var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "stadiafr-jeux-login" } }, [
      _c("div", [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "wordings" }, [
          _vm._v("\n            Déconnexion en cours...\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }